module.exports = __webpack_public_path__ + "img/subject.f0ee0ce0.svg";